import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PhotoSizeSelectActualIcon from '@mui/icons-material/PhotoSizeSelectActual';
import { Box, Button } from '@mui/material';
import { collection, query, where, getDocs } from 'firebase/firestore';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useParams } from 'react-router-dom';

import decorIconGirl from '../../assets/img/icon-girl.png';
import { getStudentHomeworkHM, setCheckedHomework, setStudentPhoto, deletObjFile } from '../../Common/Database';
import { firestore } from '../../Common/Firebase';
import { convertImageToWebp } from '../../Common/MediaConverter';
import NoItems from '../../Components/NoItems';
import GetHomeworkComp from '../../pages/CreateHomework/GetHomeworkComp';
import { getClassroomName } from '../../redux/slices/nameClassroomSlice';
import { setObjectFiles, getObjectFiles, getProgressFile } from '../../redux/slices/uploadFileSlice';
import { setObjectHomework, getUserType } from '../../redux/slices/userSlice';
import StudentHomeworkItem from '../CreateHomework/StudentHomeworkItem';

import './style.scss';

const itemsPerPage = 6;

const StudentHomeworkList = ({ mail }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { subject, userMail } = useParams();

  const [currentMail, setCurrentMail] = useState(userMail === undefined ? mail : userMail);
  const [currentPage, setCurrentPage] = useState(1);
  const [contentObj, setContentObj] = useState('');
  const [homeworkData, setHomeworkData] = useState([]);
  const [homeworkDataFirst, setHomeworkDataFirst] = useState([]);
  const [checkboxState, setCheckboxState] = useState([]);
  const [checkboxStateClickFlag, setCheckboxStateClickFlag] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);

  const [fileUpload, setFileUpload] = useState('');
  const [selectedValue, setSelectedValue] = useState(0);
  const [fileListOpen, setfileListOpen] = useState(false);
  const [fileListContent, setFileListContent] = useState([]);
  const [fileListContentItem, setFileListContentItem] = useState('');
  const [fileListIndex, setFileListIndex] = useState('');
  const [fileListSubIndex, setFileListSubIndex] = useState('');
  const [actionFullHM, setActionFullHM] = useState('');
  const [selectedKey, setSelectedKey] = useState(null);
  const [selectedSubKey, setSelectedSubKey] = useState(null);

  const fileProgressSelector = useSelector(getProgressFile);
  const filesObjectSelector = useSelector(getObjectFiles);
  const objUserInfo = useSelector(getClassroomName);
  const userType = useSelector(getUserType);

  const [getHomeworkState, setGetHomeworkState] = useState({});
  const [getObjUserInfo, setObjUserInfo] = useState({});

  const [deltaObjects, setDeltaObjects] = useState([]);

  const [keyUpdate, setKeyUpdate] = useState(0);

  useEffect(() => {
    setKeyUpdate(prev => prev + 1);
  }, [subject]);

  function transformArray(arr, delItem) {
    let newObj = {};

    arr.forEach((item, itemIndex) => {
      if (Array.isArray(item)) {
        // Для массива
        newObj[itemIndex] = {};
        item.forEach((subItem, subItemIndex) => {
          if (subItem.studentPhotos) {
            if (typeof subItem.studentPhotos === 'object' && subItem.studentPhotos.itemKey !== undefined) {
              // Если это объект с itemKey, берем массив по этому ключу и перебираем его
              console.log(
                'subItem.studentPhotos[subItem.studentPhotos.itemKey]',
                subItem.studentPhotos[subItem.studentPhotos.itemKey],
              );
              if (Array.isArray(subItem.studentPhotos[subItem.studentPhotos.itemKey])) {
                subItem.studentPhotos[subItem.studentPhotos.itemKey].forEach((actualPhotoArr, actualPhotoIndex) => {
                  newObj[itemIndex][actualPhotoIndex] = actualPhotoArr;
                });
              }
            } else if (Array.isArray(subItem.studentPhotos)) {
              // Если это просто массив
              subItem.studentPhotos.forEach((photoArr, photoIndex) => {
                if (Array.isArray(photoArr)) {
                  photoArr.forEach((actualPhotoArr, actualPhotoIndex) => {
                    newObj[itemIndex][actualPhotoIndex] = actualPhotoArr;
                  });
                }
              });
            }
          }
        });
      } else if (typeof item === 'object' && item.studentPhotos) {
        // Для объекта
        if (Array.isArray(item.studentPhotos)) {
          newObj[itemIndex] = item.studentPhotos.flat();
        }
      }
    });
    for (let key in newObj) {
      if (Array.isArray(newObj[key])) {
        newObj[key] = newObj[key].filter(item => item !== delItem);
      } else if (typeof newObj[key] === 'object') {
        for (let subKey in newObj[key]) {
          if (Array.isArray(newObj[key][subKey])) {
            newObj[key][subKey] = newObj[key][subKey].filter(item => item !== delItem);
          }
        }
      }
    }
    dispatch(setObjectFiles(newObj));
  }

  const testArr = [
    [
      {
        studentPhotos: [[['1', '4'], ['9']]],
      },
      {
        studentPhotos: [[['1', '4'], ['9']]],
      },
    ],
    [
      {
        studentPhotos: [[['1', '4'], ['9']]],
      },
      {
        studentPhotos: [[['1', '4'], ['9']]],
      },
    ],
    {
      studentPhotos: ['56'],
    },
  ];

  const toggleAccordionItem = (event, key) => {
    event.preventDefault();
    if (selectedKey === key) {
      setSelectedKey(null); // закрывает элемент, если он уже открыт
    } else {
      setSelectedKey(key); // открывает элемент
      setSelectedSubKey(null); // сбрасывает выбранный подэлемент
    }

    setObjUserInfo({});
  };

  const toggleSubAccordionItem = (event, key) => {
    const classNameTarget = event.target.className;
    event.stopPropagation();
    event.preventDefault();
    if (selectedSubKey === key && classNameTarget !== 'checkbox-homework') {
      setSelectedSubKey(null); // закрывает подэлемент, если он уже открыт
    } else if (classNameTarget !== 'checkbox-homework') {
      setSelectedSubKey(key); // открывает подэлемент
    }
  };

  const FileRenderer = ({ url, isOpen }) => {
    const [fileType, setFileType] = useState(null);
    const [iframeKey, setIframeKey] = useState(Date.now());

    useEffect(() => {
      const checkFileType = async () => {
        try {
          const response = await fetch(url);
          const blob = await response.blob();
          const type = blob.type;

          if (type.startsWith('image/')) {
            setFileType('image');
          } else if (
            type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
            type === 'application/msword'
          ) {
            setFileType('word');
          }
        } catch (error) {
          console.error('Error determining file type:', error);
        }
      };

      checkFileType();
    }, [url]);

    useEffect(() => {
      if (isOpen) {
        setIframeKey(Date.now());
      }
    }, [isOpen]);

    if (fileType === 'image') {
      return <img src={url} alt="File content" />;
    } else if (fileType === 'word') {
      const googleDocsViewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(url)}&embedded=true`;

      return (
        <iframe
          key={iframeKey}
          src={googleDocsViewerUrl}
          style={{
            border: 'none',
            minWidth: '46vw',
            height: '60vh',
            marginTop: '28px',
          }}
          title="Document Viewer"
        ></iframe>
      );
    } else {
      return <div>Loading or unsupported file type...</div>;
    }
  };

  const setGetHomeworkFunc = (id, item) => {
    setGetHomeworkState(prevState => {
      return {
        ...prevState,
        [id]: {
          item: item,
          id: id,
        },
      };
    });
  };

  function addIndexToObjects(arr, parentIndex = '') {
    return arr.map((item, index) => {
      const itemKey = parentIndex ? Number(`${parentIndex}`) : Number(`${index}`);

      if (Array.isArray(item)) {
        return addIndexToObjects(item, itemKey);
      } else if (typeof item === 'object' && item !== null) {
        return { ...item, itemKey };
      } else {
        return item;
      }
    });
  }

  function createPairs(data, completeds) {
    return data.map((item, index) => {
      return { item, completed: completeds[index] };
    });
  }

  function splitPairs(pairs) {
    return pairs.reduce(
      (acc, pair) => {
        acc.data.push(pair.item);
        acc.completeds.push(pair.completed);
        return acc;
      },
      { data: [], completeds: [] },
    );
  }

  const parseDate = dateStr => {
    const [day, month, year] = dateStr.split('.').map(Number);
    return new Date(year, month - 1, day);
  };

  function sortPairs(pairs) {
    const getMinDate = item => {
      if (Array.isArray(item)) {
        return Math.min(...item.map(x => parseDate(x.deadline).getTime()));
      } else {
        return parseDate(item.deadline).getTime();
      }
    };

    return pairs.sort((a, b) => {
      const aCompleted = Array.isArray(a.completed) ? !a.completed.includes(false) : a.completed;
      const bCompleted = Array.isArray(b.completed) ? !b.completed.includes(false) : b.completed;

      if (aCompleted !== bCompleted) {
        return aCompleted ? 1 : -1;
      } else {
        return getMinDate(a.item) - getMinDate(b.item);
      }
    });
  }

  function processArray(array, index) {
    // Проходим по всем объектам в массиве
    array.forEach(item => {
      processItem(item, index);
    });
  }

  function processItem(item, index) {
    // Если элемент является массивом
    if (Array.isArray(item)) {
      processArray(item, index);
    }
    // Если элемент является объектом
    else if (typeof item === 'object') {
      // Обновляем itemKey объекта
      item.itemKey = index;
      // Обрабатываем все значения в объекте, которые могут быть массивами или объектами
      Object.values(item).forEach(value => {
        if (Array.isArray(value)) {
          processArray(value, index);
        } else if (typeof value === 'object') {
          processItem(value, index);
        }
      });
    }
  }

  const compliteContentFunc = () => {
    if (homeworkDataFirst && homeworkDataFirst.length > 0) {
      const obj1 = Object.values(getHomeworkState);
      const obj2 = homeworkDataFirst;
      const filtred = obj1.filter((item, i) => {
        const str = JSON.stringify(obj2);
        if (str.includes(item.id)) {
          return item;
        }
      });

      const combinedArr = filtred.concat(homeworkDataFirst).reduce((acc, cur) => {
        const index = acc.findIndex(item => item.id === cur.id);
        if (index >= 0) {
          acc[index] = { ...acc[index], ...cur };
        } else {
          acc.push(cur);
        }
        return acc;
      }, []);

      const newArr = [];
      const arrCompleteds = [];
      const fullArryPhotos = [];

      combinedArr.sort((a, b) => {
        if (a.countNumbHomework && b.countNumbHomework) {
          return a.countNumbHomework - b.countNumbHomework;
        }
        // Обработка случая, если свойство countNumbHomework отсутствует в одном или обоих элементах
        return 0; // или другое значение, в зависимости от вашей логики
      });

      combinedArr.forEach(obj => {
        if (obj.item && obj.item.length > 1 && Array.isArray(obj.item)) {
          obj.item.forEach((item, index) => {
            newArr.push({
              completed: obj.subArrayCheckeds[index],
              content: obj.content,
              deadline: obj.deadline,
              mail: obj.mail,
              id: obj.id,
              item: item,
              name: obj.name,
              numb: index + 1,
              fullName: obj.name,
              subItems: obj.subItems,
              notebook: obj.notebook,
              subject: obj.subject,
              titles: obj.titles,
              subArrayCheckeds: obj.subArrayCheckeds,
              studentPhotos: obj.studentPhotos ? obj.studentPhotos : '',
            });
          });

          if (typeof obj.studentPhotos !== 'undefined') {
            fullArryPhotos.push(obj.studentPhotos);
          }
          arrCompleteds.push(obj.subArrayCheckeds);
        } else {
          newArr.push({
            completed: obj.completed,
            content: obj.content,
            deadline: obj.deadline,
            mail: obj.mail,
            id: obj.id,
            item: obj.item ? obj.item[0] : '',
            name: obj.name,
            titles: obj.titles,
            subItems: obj.subItems,
            notebook: obj.notebook,
            subject: obj.subject,
            subArrayCheckeds: obj.subArrayCheckeds,
            studentPhotos: obj.studentPhotos ? obj.studentPhotos : '',
          });
          if (typeof obj.studentPhotos !== 'undefined' && typeof obj.studentPhotos[Symbol.iterator] === 'function') {
            fullArryPhotos.push(...obj.studentPhotos);
          }
          arrCompleteds.push(obj.completed);
        }
      });

      const newArr1 = newArr.map((obj, index) => {
        return { ...obj };
      });

      const newArr2 = newArr1.reduce((acc, obj) => {
        if (obj.numb) {
          const existingGroup = acc.find(group => group[0]?.name === obj.name);
          if (existingGroup) {
            existingGroup.push(obj);
          } else {
            acc.push([obj]);
          }
        } else {
          acc.push(obj);
        }
        return acc;
      }, []);

      const newArr3 = addIndexToObjects(newArr2);

      const pairs = createPairs(newArr3, arrCompleteds);

      let sortedPairs = sortPairs(pairs);
      sortedPairs = sortedPairs.map((pair, index) => {
        if (!Array.isArray(pair.item)) {
          pair.item.itemKey = index;
        }
        return pair;
      });

      const { data: sortedHomeworkData, completeds: sortedArrCompleteds } = splitPairs(sortedPairs);

      // Запускаем обработку с входными данными
      const newArrsortedHomeworkData = sortedHomeworkData;
      newArrsortedHomeworkData.map((item, index) => {
        return processItem(item, index);
      });

      setCheckboxState(sortedArrCompleteds);
      setHomeworkData(newArrsortedHomeworkData);
    }
  };

  useEffect(() => {
    compliteContentFunc();
  }, [getHomeworkState, homeworkDataFirst]);

  useEffect(() => {
    if (!initialLoad) {
      setTimeout(() => {
        const pairs = createPairs(homeworkData, checkboxState);

        let sortedPairs = sortPairs(pairs);
        sortedPairs = sortedPairs.map((pair, index) => {
          if (!Array.isArray(pair.item)) {
            pair.item.itemKey = index;
          }
          return pair;
        });

        const { data: sortedHomeworkData, completeds: sortedArrCompleteds } = splitPairs(sortedPairs);

        // Запускаем обработку с входными данными
        const newArrsortedHomeworkData = sortedHomeworkData;
        newArrsortedHomeworkData.map((item, index) => {
          return processItem(item, index);
        });

        setCheckboxState(sortedArrCompleteds);
        setHomeworkData(newArrsortedHomeworkData);
      }, 100);
    } else {
      setInitialLoad(false);
    }
  }, [checkboxStateClickFlag]);

  const getHomeworkContent = async subject => {
    setContentObj({});
    setHomeworkData([]);
    const q = query(collection(firestore, 'homeworks-content-student'), where('subject', '==', subject));

    const querySnapshot = await getDocs(q);

    let objContent = {};

    const content = querySnapshot.docs.map(doc => {
      if (doc.exists()) {
        const ops = JSON.parse(doc.data().content);
        const id = doc.data().id;
        objContent[doc.data().id] = doc.data();
        return { ops: ops, id: id };
      } else {
        return null;
      }
    });

    setDeltaObjects(content);

    setContentObj(objContent);

    getStudentHomeworkHM(currentMail, subject).then(data => {
      try {
        let mapList = Object.values(data);
        setHomeworkDataFirst(mapList);
      } catch (error) {}
    });
  };

  const totalPages = itemsPerPage ? Math.ceil(homeworkData.length / itemsPerPage) : '';

  const getPageItems = page => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    return homeworkData.slice(startIndex, endIndex);
  };

  const handlePageClick = page => {
    setCurrentPage(page);
  };

  useEffect(() => {
    setCurrentPage(1);
    setContentObj('');
    setHomeworkData([]);
    setHomeworkDataFirst([]);
    setCheckboxState([]);
    setCheckboxStateClickFlag(false);
    setInitialLoad(true);

    setFileUpload('');
    setSelectedValue(0);
    setfileListOpen(false);
    setFileListContent([]);
    setFileListContentItem('');
    setFileListIndex('');
    setFileListSubIndex('');
    setActionFullHM('');
    setSelectedKey(null);
    setSelectedSubKey(null);

    setGetHomeworkState({});
    setObjUserInfo({});
    setDeltaObjects([]);
    setKeyUpdate(0);
    getHomeworkContent(subject);
    compliteContentFunc();
  }, [subject]);

  const handleCheckboxChange = (event, index, elementHomework, subIndex) => {
    const isChecked = event.target.checked;

    if (Array.isArray(elementHomework)) {
      const checkArray = [...checkboxState];
      checkArray[index] = [...checkArray[index]];
      checkArray[index][subIndex] = isChecked;
      setCheckboxState(checkArray);
      setCheckedHomework(
        currentMail,
        elementHomework,
        checkArray[index],
        isChecked,
        elementHomework[subIndex].subItems,
        elementHomework[subIndex].id,
        subIndex,
      );
    } else {
      const checkArray = [...checkboxState];
      checkArray[index] = isChecked;
      setCheckboxState(checkArray);
      setCheckedHomework(
        currentMail,
        elementHomework,
        checkArray[index],
        isChecked,
        elementHomework.subItems,
        elementHomework.id,
        subIndex,
      );
    }

    setCheckboxStateClickFlag(prevState => !prevState);
  };

  const handleFileUpload = async (event, item, index) => {
    event.stopPropagation();
    let file = event.target.files[0];
    if (file && file['type'].split('/')[0] === 'image') {
      file = await convertImageToWebp(URL.createObjectURL(file), file);
    }
    setFileUpload(file);
    if (file) {
      setStudentPhoto(file, file.name, currentMail, item.subItems, item.id, index, '', item);
      setFileUpload('');
    }
  };

  const handleFileUploadSub = async (event, subFileItem, parentItemIndex, subItemIndex, item) => {
    event.stopPropagation();

    let file = event.target.files[0];
    if (file && file['type'].split('/')[0] === 'image') {
      file = await convertImageToWebp(URL.createObjectURL(file), file);
    }
    setFileUpload(file);
    if (file) {
      setStudentPhoto(
        file,
        file.name,
        currentMail,
        subFileItem[0].subItems,
        subFileItem[0].id,
        parentItemIndex,
        subItemIndex,
        item,
      );
      setFileUpload('');
    }
  };

  const fileListOpenFunc = (array, item, subIndex, index) => {
    setFileListIndex(index);
    setFileListSubIndex(subIndex);
    setFileListContentItem(item);
    setFileListContent(array);
    setfileListOpen(true);
    setActionFullHM('');
  };

  const fileListOpenFuncFull = (array, item, action, index) => {
    setFileListIndex(index);
    setFileListSubIndex(index);
    setFileListContentItem(item);
    setFileListContent(array);
    setfileListOpen(true);
    setActionFullHM(action);
  };

  const fileListCloseFunc = () => {
    setFileListSubIndex('');
    setFileListContentItem('');
    setFileListContent('');
    setfileListOpen(false);
    setActionFullHM('');
  };

  const deleteFileFunc = (item, itemParent, indexItem) => {
    if (actionFullHM !== 'fullHM') {
      const copiedObject = JSON.parse(JSON.stringify(filesObjectSelector));
      const filteredArr = copiedObject[fileListIndex][fileListSubIndex].filter(element => element !== item);
      copiedObject[fileListIndex][fileListSubIndex] = filteredArr;

      setFileListContent(copiedObject[fileListIndex][fileListSubIndex]);

      if (copiedObject[fileListIndex][fileListSubIndex].length < 1) {
        setfileListOpen(false);
      }

      transformArray(homeworkData, item);

      deletObjFile(item, itemParent, currentMail, copiedObject, fileListIndex, fileListSubIndex, actionFullHM);
    } else {
      const copiedObject = JSON.parse(JSON.stringify(filesObjectSelector));

      const filteredArr = copiedObject[fileListSubIndex].filter(element => element !== item);
      copiedObject[fileListSubIndex] = filteredArr;

      setFileListContent(copiedObject[fileListSubIndex]);

      if (copiedObject[fileListSubIndex].length < 1) {
        setfileListOpen(false);
      }

      transformArray(homeworkData, item);

      deletObjFile(item, itemParent, currentMail, copiedObject, fileListIndex, fileListSubIndex, actionFullHM);
    }
  };

  const goToNotebook = (currentMail, subject, item) => {
    if (userType === 'Student') {
      dispatch(setObjectHomework(item));
      navigate(`/notebook/${currentMail}/${subject}/Homework`);
    }
    if (userType === 'Teacher') {
      navigate(`/notebook/${userMail}/${subject}`);
    }
  };

  const isSubjectMatch = data => {
    if (Array.isArray(data)) {
      return data[0] && data[0].subject === subject; // предполагая, что у вас есть переменная состояния subject
    } else {
      return data.subject === subject; // предполагая, что у вас есть переменная состояния subject
    }
  };

  return (
    <div className="homework-list-page container">
      <div className={fileProgressSelector > 0 ? 'progress-loader-wrap active' : 'progress-loader-wrap '}>
        <div className="progress-loader-item">
          <div className="progress-loader-content" style={{ width: fileProgressSelector + '%' }}>
            <span>{fileProgressSelector}%</span>
          </div>
        </div>
      </div>

      <div className="title-wrap">
        {subject && (
          <h1>
            <span>{t('Homework in the subject')}</span> <span>{t(subject)}</span>
          </h1>
        )}
      </div>

      <div className="decor-item-img">
        <img src={decorIconGirl} alt="decor-icon" />
      </div>

      <div className="homework-list-block">
        <div className="hidden">
          {deltaObjects &&
            deltaObjects.length > 0 &&
            deltaObjects.map((item, i) => (
              <GetHomeworkComp
                key={i + keyUpdate + JSON.stringify(contentObj)}
                content={item}
                setGetHomework={setGetHomeworkFunc}
              />
            ))}
        </div>

        <ul className="homework-list">
          {homeworkData.length > 0 &&
          getPageItems(currentPage) &&
          getPageItems(currentPage).length > 0 &&
          isSubjectMatch(getPageItems(currentPage)[0]) ? (
            getPageItems(currentPage).map((item, i) => {
              if (Array.isArray(item)) {
                return (
                  <li className="homework-list-item sub-list-item" key={item[0].id + i}>
                    <div className="sub-heading-item" onClick={e => toggleAccordionItem(e, i)}>
                      <div className="heading-item">
                        <h2>
                          <span className="subject">{t(subject) + ' - '}</span>
                          {item[0].name}
                        </h2>
                      </div>

                      <span className="sub-list-item-right">
                        {checkboxState[item[0].itemKey].every(value => value === true) ? (
                          <span className="state-checked-text true">{t('homeworkDone')}</span>
                        ) : (
                          <span className="state-checked-text false">{t('homeworkProgress')}</span>
                        )}
                      </span>

                      <div className="deadline-block deadline-block-sub-items">
                        <span className="deadline-text">
                          {t('deadlineHomework')}
                          {' ' + item[0].deadline}
                        </span>
                      </div>
                    </div>

                    <div
                      className={`sub-list-item-wrap acardion-item sub-items-acr ${
                        selectedKey === i ? 'open' : ''
                      } ${getObjUserInfo.name === item[0].name ? 'open' : ''}`}
                    >
                      {item[0].notebook && (
                        <a
                          href="#"
                          className="button-notebooks"
                          onClick={e => goToNotebook(currentMail, subject, item)}
                        >
                          {t('to-notebook')}
                        </a>
                      )}

                      {item &&
                        item.length > 0 &&
                        item.map((subItem, subIndex) => {
                          return (
                            <div className="sub-list-item-col" key={item[0].id + item[0].itemKey + subIndex}>
                              <div
                                className="homework-list-item-row"
                                onClick={e => toggleSubAccordionItem(e, subIndex)}
                              >
                                <div className="heading-item heading-item-point">
                                  <h2>
                                    {subIndex + 1 + '. '}
                                    {subItem.titles[subIndex]}
                                  </h2>

                                  <span className="list-item-left">
                                    {userType !== 'Teacher' && (
                                      <>
                                        {checkboxState[item[0].itemKey] ? (
                                          <span className="name-homework-span">{t('done')}</span>
                                        ) : (
                                          <span className="name-homework-span">{t('implementation')}</span>
                                        )}

                                        <input
                                          type="checkbox"
                                          className="checkbox-homework"
                                          checked={checkboxState[item[0].itemKey][subIndex]}
                                          onChange={e => handleCheckboxChange(e, item[0].itemKey, item, subIndex)}
                                        />
                                        <label>
                                          <span className="name-homework"></span>
                                        </label>
                                      </>
                                    )}
                                  </span>
                                </div>
                              </div>

                              <div
                                className={`acardion-sub acardion-item ${selectedSubKey === subIndex ? 'open' : ''} `}
                              >
                                <StudentHomeworkItem key={i + keyUpdate} content={subItem.item} />

                                {userType !== 'Teacher' && (
                                  <div className="wrap-bottom-row">
                                    <div className="file-popup-btn">
                                      <div className="file-popup-open-content">
                                        <h4>{t('choose File')}</h4>
                                      </div>
                                      <input
                                        className="file-popup-open-btn"
                                        type="file"
                                        value={fileUpload}
                                        onChange={e => handleFileUploadSub(e, item, item[0].itemKey, subIndex, item)}
                                      />
                                    </div>

                                    {typeof filesObjectSelector !== 'undefined' &&
                                      filesObjectSelector &&
                                      Object.values(filesObjectSelector).length > 0 &&
                                      filesObjectSelector[item[0].itemKey] &&
                                      filesObjectSelector[item[0].itemKey][subIndex] &&
                                      filesObjectSelector[item[0].itemKey][subIndex].length > 0 && (
                                        <button
                                          className="file-list-open"
                                          onClick={e =>
                                            fileListOpenFunc(
                                              filesObjectSelector[item[0].itemKey][subIndex],
                                              subItem,
                                              subIndex,
                                              item[0].itemKey,
                                            )
                                          }
                                        >
                                          <span>{t('view files')}</span>
                                          <PhotoSizeSelectActualIcon />
                                        </button>
                                      )}
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </li>
                );
              } else {
                return (
                  <li className="homework-list-item" key={item.id + item.itemKey}>
                    <div
                      className="homework-list-item-row click-item"
                      onClick={e => toggleAccordionItem(e, item.itemKey)}
                    >
                      <div className="heading-item">
                        <h2>
                          <span className="subject">{t(subject) + ' - '}</span>
                          {item.name}
                        </h2>

                        <span className="list-item-right">
                          {checkboxState[item.itemKey] === true ? (
                            <span className="state-checked-text true">{t('homeworkDone')}</span>
                          ) : (
                            <span className="state-checked-text false">{t('homeworkProgress')}</span>
                          )}
                        </span>
                      </div>

                      <div className="deadline-block">
                        <span className="deadline-text">
                          {t('deadlineHomework')}
                          {' ' + item.deadline}
                        </span>
                      </div>
                    </div>

                    <div
                      className={`acardion-item ${
                        selectedKey === item.itemKey ? 'open' : ''
                      } ${getObjUserInfo.name === item.name ? 'open' : ''}`}
                    >
                      <div className="homework-list-item-row sub-title">
                        <div className="heading-item">
                          <span className="list-item-right">
                            {item.notebook && (
                              <a
                                href="#"
                                className="btn more btn-view btn-secondary"
                                onClick={e => goToNotebook(currentMail, subject, item)}
                              >
                                {t('to-notebook')}
                              </a>
                            )}
                          </span>
                        </div>

                        <span className="list-item-left">
                          {userType !== 'Teacher' && (
                            <>
                              <input
                                type="checkbox"
                                className="checkbox-homework"
                                checked={checkboxState[item.itemKey]}
                                onChange={e => handleCheckboxChange(e, item.itemKey, item)}
                                id={item.itemKey}
                              />
                              <label htmlFor={item.itemKey}>
                                <span className="name-homework">{t('done')}</span>
                              </label>
                            </>
                          )}
                        </span>
                      </div>

                      <StudentHomeworkItem key={i + keyUpdate} content={item.item} />

                      {userType !== 'Teacher' && (
                        <div className="wrap-bottom-row-full-item">
                          <div className="file-upload">
                            <div className="file-upload-content">
                              <h4>{t('choose File')}</h4>
                            </div>
                            <input
                              className="file-upload-input"
                              type="file"
                              value={fileUpload}
                              onChange={e => handleFileUpload(e, item, item.itemKey)}
                            />
                          </div>
                          {typeof filesObjectSelector !== 'undefined' &&
                            filesObjectSelector &&
                            Object.values(filesObjectSelector).length > 0 &&
                            filesObjectSelector[item.itemKey] &&
                            filesObjectSelector[item.itemKey].length > 0 && (
                              <button
                                className="file-list-open"
                                onClick={e =>
                                  fileListOpenFuncFull(filesObjectSelector[item.itemKey], item, 'fullHM', item.itemKey)
                                }
                              >
                                <span>{t('view files')}</span>
                                <PhotoSizeSelectActualIcon />
                              </button>
                            )}
                        </div>
                      )}
                    </div>
                  </li>
                );
              }
            })
          ) : (
            <div>
              <NoItems titleNoItems={"You don't have homework for this subject yet"} />
            </div>
          )}
        </ul>

        {homeworkData.length > 6 && (
          <Box mt={2} className="pagination">
            <Button
              disabled={currentPage === 1}
              startIcon={<ArrowBackIosIcon />}
              className="button-arrow"
              onClick={() => handlePageClick(currentPage - 1)}
            ></Button>

            {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
              <Button
                key={page}
                variant={currentPage === page ? 'contained' : 'outlined'}
                className="button-pagin-numb"
                onClick={() => handlePageClick(page)}
              >
                {page}
              </Button>
            ))}
            <Button
              disabled={currentPage === totalPages}
              endIcon={<ArrowForwardIosIcon />}
              className="button-arrow"
              onClick={() => handlePageClick(currentPage + 1)}
            ></Button>
          </Box>
        )}

        {fileListOpen && (
          <div className="files-list-popup">
            <div className="files-list-popup-content">
              <div className="files-list-popup-top">
                {actionFullHM !== 'fullHM' ? (
                  <h2>Пункт {'№ ' + (fileListContentItem.itemKey + 1)}</h2>
                ) : (
                  <h2>{t('homework')}</h2>
                )}

                <button
                  className="btn btn-icon"
                  onClick={e => {
                    fileListCloseFunc();
                  }}
                >
                  <span className="icon icon-plus"></span>
                </button>
              </div>

              <ul className="list-files">
                {fileListContent &&
                  fileListContent.length > 0 &&
                  fileListContent.map((item, index) => {
                    return (
                      <>
                        <li key={item}>
                          <FileRenderer url={item} isOpen={fileListOpen} />
                        </li>
                        <span className="delete-btn" onClick={e => deleteFileFunc(item, fileListContentItem, index)}>
                          <DeleteForeverIcon />
                        </span>
                      </>
                    );
                  })}
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(StudentHomeworkList);
